import { _ as _extends } from '../_rollupPluginBabelHelpers-e8fb2e5c.js';
import React__default, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { c as classnames } from '../index-6ff23041.js';
import Empty from '../Empty/index.js';
import Tooltip from '../Tooltip/index.js';
import Checkbox from '../Checkbox/index.js';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import '../Popover-f4d1cac0.js';
import '../_commonjsHelpers-24198af3.js';
import 'react-dom';
import '../configs-fed6ac34.js';
import '../index-a0e4e333.js';
import '../dateValidation-67caec66.js';
import '../hooks/useDeviceType.js';
import '../hooks/useWindowSize.js';
import '../GeneUIProvider/index.js';
import '../checkboxRadioSwitcher-5b69d7bd.js';
import '../guid-8ddf77b3.js';

var css_248z = "[data-gene-ui-version=\"2.13.0\"] .image-holder{--image-border-radius:1rem;padding:100% 0 0;position:relative;transition:box-shadow .4s;-webkit-user-select:none;user-select:none;width:100%}[data-gene-ui-version=\"2.13.0\"] .image-holder.with-border{--distance:0.8rem;--image-border-radius:0.6rem;border-radius:1rem;box-shadow:inset 0 0 0 1px rgba(var(--background-sc-rgb),.2)}[data-gene-ui-version=\"2.13.0\"] .image-holder.with-border:hover{box-shadow:inset 0 0 0 1px rgba(var(--background-sc-rgb),.5)}[data-gene-ui-version=\"2.13.0\"] .image-holder.with-border.error{box-shadow:inset 0 0 0 1px rgba(var(--danger-rgb),.5)}[data-gene-ui-version=\"2.13.0\"] .image-holder.with-border.error:hover{box-shadow:inset 0 0 0 1px var(--danger)}[data-gene-ui-version=\"2.13.0\"] .image-content{bottom:var(--distance,0);left:var(--distance,0);position:absolute;right:var(--distance,0);top:var(--distance,0)}[data-gene-ui-version=\"2.13.0\"] .image-content img{border-radius:var(--image-border-radius);display:block;height:100%;object-fit:cover;width:100%}[data-gene-ui-version=\"2.13.0\"] .image-label-holder{background:#0003;border-radius:var(--image-border-radius);cursor:pointer;height:100%;left:0;position:absolute;top:0;width:100%}[data-gene-ui-version=\"2.13.0\"] .image-heading{align-items:center;display:flex;left:0;padding:0 .7rem;position:absolute;top:1.2rem;width:100%}[data-gene-ui-version=\"2.13.0\"] .image-heading>li{margin:0 .5rem}[data-gene-ui-version=\"2.13.0\"] .image-heading>li.image-cra{background:#fff;border-radius:.3rem;flex-shrink:0}[data-gene-ui-version=\"2.13.0\"] .image-heading>li.image-title{color:#fff;flex:auto;font:700 1.2rem/2rem var(--font-family)}[data-gene-ui-version=\"2.13.0\"] .image-actions-holder{align-items:center;background:#0009;border-radius:var(--image-border-radius);display:flex;height:100%;justify-content:center;left:0;position:absolute;top:0;transition:opacity .4s,visibility .4s;width:100%}[data-gene-ui-version=\"2.13.0\"] .image-holder:not(:hover) .image-actions-holder{opacity:0;visibility:hidden}[data-gene-ui-version=\"2.13.0\"] .image-actions{align-items:center;display:flex}[data-gene-ui-version=\"2.13.0\"] .image-actions>*{box-shadow:inset 0 0 0 5rem #ffffffe6}html:not([dir=rtl]) .image-actions>*+*{margin-left:.5rem}html[dir=rtl] .image-actions>*+*{margin-right:.5rem}[data-gene-ui-version=\"2.13.0\"] .image-empty-state-holder{bottom:0;left:0;margin:auto;position:absolute;right:0;top:0}";
styleInject(css_248z);

function Image(_ref) {
  let {
    src,
    withBorder,
    selectMode,
    actions,
    title,
    imageProps,
    checkboxProps,
    className,
    isValid,
    tooltipTitle,
    emptyText,
    ...restProps
  } = _ref;
  const isValidSource = useMemo(() => typeof src === 'string' && src !== '', [src]);
  return /*#__PURE__*/React__default.createElement(Tooltip, {
    title: tooltipTitle
  }, /*#__PURE__*/React__default.createElement("div", _extends({
    className: classnames('image-holder', className, {
      'with-border': withBorder,
      error: !isValid
    })
  }, restProps), isValidSource ? /*#__PURE__*/React__default.createElement("div", {
    className: "image-content"
  }, /*#__PURE__*/React__default.createElement("img", _extends({
    src: src,
    alt: title
  }, imageProps)), selectMode && /*#__PURE__*/React__default.createElement("label", {
    className: "image-label-holder"
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: "image-heading"
  }, /*#__PURE__*/React__default.createElement("li", {
    className: "image-cra"
  }, /*#__PURE__*/React__default.createElement(Checkbox, _extends({
    size: "big"
  }, checkboxProps))), title && /*#__PURE__*/React__default.createElement("li", {
    className: "image-title ellipsis-text"
  }, title))), actions && !selectMode && /*#__PURE__*/React__default.createElement("div", {
    className: "image-actions-holder"
  }, title && /*#__PURE__*/React__default.createElement("ul", {
    className: "image-heading"
  }, /*#__PURE__*/React__default.createElement("li", {
    className: "image-title ellipsis-text"
  }, title)), /*#__PURE__*/React__default.createElement("div", {
    className: "image-actions"
  }, actions))) : /*#__PURE__*/React__default.createElement(Empty, {
    type: "data",
    title: emptyText,
    className: "image-empty-state-holder"
  })));
}
Image.propTypes = {
  /**
   * Image path to display
   */
  src: PropTypes.string.isRequired,
  /**
   * Will add a border when set to "true"
   */
  withBorder: PropTypes.bool,
  /**
   * The property will add a checkbox and an overlay over the image.
   */
  selectMode: PropTypes.bool,
  /**
   * Customize checkbox(will be rendered only when "selectMode" is set to "true").
   */
  checkboxProps: PropTypes.object,
  /**
   * Customize image tag with this property.
   */
  imageProps: PropTypes.object,
  /**
   * The property will render "actions" when "selectMode" is not setted to "true". Any valid React node
   */
  actions: PropTypes.node,
  /**
   * Will add a title to the top of Image atom. Any valid React node
   */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
   * Title for 'Tooltip'.
   */
  tooltipTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
   * Addional className
   */
  className: PropTypes.string,
  /**
   * Image atom also can be included in "Form" organism. It can be validated as other "Form" elements
   */
  isValid: PropTypes.bool,
  /**
   * Empty state text for component
   */
  emptyText: PropTypes.string
};
Image.defaultProps = {
  withBorder: false,
  selectMode: false,
  isValid: true,
  emptyText: 'No image to display'
};

export { Image as default };
